module.exports = __webpack_public_path__ + "static/media/12x12-4.f16f2b14.png";